// Blog post metadata. The actual JSX content lives in /pages/blog/*.
export const BLOG_POSTS = [
    {
        slug: "how-csv-files-work",
        title: "How CSV Files Work — A Beginner's Walkthrough",
        excerpt: "What's actually inside a .csv file? Open one in Notepad and we'll decode it line by line. No prior experience needed.",
        date: "Feb 8, 2026",
        readTime: "5 min read",
        category: "Beginner",
    },
    {
        slug: "best-csv-editor",
        title: "What Makes a Good CSV Editor in 2026?",
        excerpt: "We compared the popular CSV editors on what actually matters: speed, mobile, privacy, and not corrupting your data.",
        date: "Feb 8, 2026",
        readTime: "7 min read",
        category: "Comparison",
    },
    {
        slug: "open-large-csv-files",
        title: "How to Open Large CSV Files Without Crashing Your Computer",
        excerpt: "When Excel chokes on a 100MB file, what do you do? Three real techniques that work — including what to do if your file is over a gigabyte.",
        date: "Feb 8, 2026",
        readTime: "6 min read",
        category: "How-to",
    },
    {
        slug: "why-csv-still-matters",
        title: "Why CSV Files Still Matter in 2026",
        excerpt: "AI is everywhere. Cloud platforms have proprietary formats. Yet CSV — invented in the 1970s — is still the most-traded data format on the internet. Here's why.",
        date: "Feb 8, 2026",
        readTime: "8 min read",
        category: "Insight",
    },
];

export default BLOG_POSTS;
